import ScrollToTop from "react-scroll-to-top";
import Header from '../Layout/Header/Header';
import Sidebar from '../Layout/Sidebar/Sidebar';
import Widgets from '../Widgets/Widgets';

const Deshboard = () => {
    const customViewsIframe = document.querySelector('#customviews-container')!;
    customViewsIframe.setAttribute('style', "height: 0; width: 0;");
    return (
        <div className="layout-wrapper">
            <Header/>
            <Sidebar/>
            <Widgets/>
            <ScrollToTop smooth color="#0019FF" />
        </div>
    )
}
export default Deshboard;